import { HttpRequest } from '../../components/HttpRequest';

const base_url = process.env.REACT_APP_WEB_SOCKET_URL;

export const paymentsApi = {
  // Fetch available payment methods and their status
  async getPaymentMethods() {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/get_payment_methods_with_status`
      });

      if ((response?.status === 200 || response?.status === 201) && response?.response?.data) {
        const data = response.response.data;

        // Parse payment method statuses from API response
        const mpesaMethod = data.find(method => method.name === "Mpesa");
        const cardMethod = data.find(method => method.name === "Card");
        const banksMethod = data.find(method => method.name === "Banks");

        // Extract KCB Mobile Money status from nested structure
        let mobileMoneyStatus = false;
        if (banksMethod?.paymentOptions) {
          const kcbOption = banksMethod.paymentOptions.find(opt => opt.name === "KCB");
          if (kcbOption?.kcb) {
            const mobileMoneyMethod = kcbOption.kcb.find(method => method.name === "Mobile Money");
            mobileMoneyStatus = mobileMoneyMethod?.status || false;
          }
        }

        return {
          success: true,
          methods: {
            mpesa: mpesaMethod?.status || false,
            card: cardMethod?.status || false,
            paybill: mobileMoneyStatus, // KCB Mobile Money
            momo: false // MTN Momo not in current API response
          },
          rawData: data,
          bankPaybillStatus: banksMethod?.status || false,
          cashStatus: data.find(method => method.name === "Cash")?.status || false
        };
      }

      return {
        success: false,
        methods: {
          mpesa: false,
          card: false,
          paybill: false,
          momo: false
        },
        rawData: []
      };
    } catch (error) {
      console.error('Error fetching payment methods:', error);
      return {
        success: false,
        methods: {
          mpesa: false,
          card: false,
          paybill: false,
          momo: false
        },
        rawData: []
      };
    }
  },

  // Initiate payment (STK Push for M-Pesa, Paybill, Card)
  async initiateStkPush(paymentData) {
    try {
      const {
        amount,
        phone,
        businessId,
        orderIds,
        paymentMethod
      } = paymentData;

      // Determine the correct endpoint based on payment method
      let endpoint = '';
      if (paymentMethod === 'mpesa') {
        endpoint = '/api/pushstk';
      } else if (paymentMethod === 'kcbpaybill') {
        endpoint = '/api/v1/payments/initiate_kcb_stk_push';
      } else if (paymentMethod === 'card') {
        endpoint = '/api/v1/payments/card/pay';
      }

      const payload = {
        amount,
        phone,
        businessId,
        orderIds,
        type: 'order',
        paymentChanel: 'Web',
        discount: 0
      };

      const response = await HttpRequest({
        method: 'POST',
        url: endpoint,
        body: payload
      });

      if (response?.status === 200 || response?.status === 201) {
        const stkOrderId = response?.response?.data?.stkOrderId;
        const invoiceData = response?.response?.data?.data?.invoiceInformation;
        const paymentLink = invoiceData?.paymentLink;
        const invoiceNumber = invoiceData?.invoiceNumber;

        return {
          success: true,
          stkOrderId,
          paymentLink,
          invoiceNumber,
          response: response.response?.data
        };
      }

      return {
        success: false,
        message: response?.response?.message || 'Failed to initiate payment'
      };
    } catch (error) {
      console.error('Error initiating STK push:', error);
      return {
        success: false,
        message: error.message || 'Failed to initiate payment'
      };
    }
  },

  // Check payment status
  async checkPaymentStatus(pushyTransactionId, businessNo) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: `/api/order_payment_status`,
        body: {
          pushyTransactionId,
          businessNo
        }
      });

      if (response?.status === 200 || response?.status === 201) {
        // Return the complete response including order, data, and transactionsList
        return {
          success: true,
          message: response?.response?.message || 'Payment verified',
          // Top-level API response fields
          Status: response?.response?.Status,
          // Payment data
          data: response?.response?.data,
          // Order details
          order: response?.response?.order,
          // Transaction history
          transactionsList: response?.response?.transactionsList,
          // Full response for debugging
          fullResponse: response?.response
        };
      }

      return {
        success: false,
        message: response?.response?.statusMessage || 'Payment status check failed'
      };
    } catch (error) {
      console.error('Error checking payment status:', error);
      return {
        success: false,
        message: error.message || 'Failed to check payment status'
      };
    }
  },

  // Open payment link in new window
  openPaymentLink(paymentLink) {
    if (paymentLink) {
      const cacheBustedLink = `${paymentLink}?t=${new Date().getTime()}`;
      window.open(cacheBustedLink);
    }
  },

  // Setup WebSocket listener for payment status
  setupPaymentListener(orderId, callbacks) {
    const socket = new WebSocket(`${base_url}/notification/${orderId}`);

    socket.addEventListener('message', function (event) {
      const data = JSON.parse(event.data);

      if (data?.status === "OK") {
        if (callbacks?.onInfo) {
          callbacks.onInfo(data?.message);
        }
      } else if (data?.status === "SUCCESS") {
        if (callbacks?.onSuccess) {
          callbacks.onSuccess(data?.message || "Payment successful");
        }
        socket.close();
      } else {
        if (callbacks?.onError) {
          callbacks.onError(data?.response?.message || data?.statusMessage || 'Payment processing failed');
        }
        socket.close();
      }
    });

    socket.addEventListener('error', function (error) {
      if (callbacks?.onError) {
        callbacks.onError('WebSocket connection error');
      }
      socket.close();
    });

    return socket;
  }
};
